/* eslint-disable */
require('./add-contact-w')
require('./alert_1')
require('./alert')
require('./arrow-black')
require('./arrow')
require('./attachment')
require('./back')
require('./bad')
require('./bad2')
require('./bill (eur)')
require('./birthday')
require('./blood pressure')
require('./bolt danger')
require('./calories')
require('./chat')
require('./check')
require('./closing')
require('./comment')
require('./dashboard')
require('./download')
require('./edit-w')
require('./edit')
require('./fall')
require('./file')
require('./geo fencing')
require('./go to')
require('./graph biometric')
require('./health report')
require('./heartbeat')
require('./home')
require('./local')
require('./logout')
require('./mail')
require('./medical doc')
require('./menu')
require('./more')
require('./my idicare')
require('./no alert')
require('./o2')
require('./password')
require('./pedometer 2')
require('./pedometer')
require('./pills')
require('./pills2')
require('./plus-w')
require('./same')
require('./same2')
require('./save')
require('./search')
require('./see more 2')
require('./see more')
require('./send')
require('./sethoscope')
require('./settings')
require('./support') // added //
require('./skip')
require('./skip2')
require('./star of life')
require('./temperature')
require('./timeline')
require('./trash')
require('./user')
require('./v')
require('./v2')
require('./walking')
require('./watch')
require('./watches')
require('./well')
require('./well2')
require('./x')
require('./x2')



// WEBPACK FOOTER //
// ./src/icons/index.js